import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Trail } from '../dto/trail';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TrailService {

  private apiUrl = environment.apiRoot + '/trial';

  constructor(private http: HttpClient) { }

  getAllTrialsOfVessel(vesselId: number): Observable<Trail[]> {
    return this.http.get<Trail[]>(this.apiUrl + '/allofvessel?vesselId=' + vesselId);
  }

  getTrialById(trialId: number): Observable<Trail> {
    return this.http.get<Trail>(this.apiUrl + '/details?trialId=' + trialId);
  }

  createTrial(vesselId: number): Observable<Trail> {
    let model = { "id": 0, "vessel_id": vesselId, "name": "new trial" };
    return this.http.post<Trail>(this.apiUrl + '/new', model);
  }

  updateTrial(model: Trail): Observable<Trail> {
    return this.http.put<Trail>(this.apiUrl + '/update', model);
  }

  deleteTrial(trialId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?trialId=' + trialId);
  }

  getTrialReport(trialId: number, reportType: string): Observable<Blob> {
    return this.http.get(this.apiUrl + '/report?trialId=' + trialId + '&type=' + reportType, { responseType: 'blob' });
  }

  getGeneratedTrialReport(reportName: string): Observable<Blob> {
    return this.http.get(this.apiUrl + '/report-download?fileName=' + reportName, { responseType: 'blob' });
  }

  templateCopyTrial(trialId: number, vesselId: number): Observable<Trail> {
    return this.http.get<Trail>(this.apiUrl + '/templateCopy?trialId=' + trialId + '&vesselId=' + vesselId);
  }

  deleteTrialTemplate(trialId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/deleteTrialTemplate?trialId=' + trialId);
  }
}
